<template>
  <IconLucideCloudDownload />
</template>
